const setChatList = (chats) => {
    localStorage.setItem('personal_chatList', JSON.stringify(chats));
}

const getChatList = () => {
    return JSON.parse(localStorage.getItem('personal_chatList')) || [];
}

const syncChat = (chat) => {
    if (!chat) return;
    const chats = JSON.parse(localStorage.getItem('personal_chats')) || [];
    const existingChatIndex = chats.findIndex(c => c?.id === chat?.id);

    if (existingChatIndex > -1) {
        chats[existingChatIndex] = chat;
    } else {
        chats.push(chat);
    }
    
    localStorage.setItem('personal_chats', JSON.stringify(chats));
}

const pushMoreChat = (chat) => {
    if (!chat) return null;
    const chats = JSON.parse(localStorage.getItem('personal_chats')) || [];
    const existingChatIndex = chats.findIndex(c => c?.id === chat?.id);
    
    if (existingChatIndex > -1) {
        const existingChat = chats[existingChatIndex];
        chat.messages = [...chat.messages, ...existingChat.messages];
        chats[existingChatIndex] = chat;
    }
    
    localStorage.setItem('personal_chats', JSON.stringify(chats));
    return chat;
}

const getFirstChat = () => {
    const chats = JSON.parse(localStorage.getItem('personal_chats')) || [];
    return chats.length > 0 ? chats[0] : null;
}

const getChat = (chatId) => {
    const chats = JSON.parse(localStorage.getItem('personal_chats')) || [];
    return chats.find(chat => String(chat?.id) === String(chatId));
}

const deleteChat = (chatId) => {
    const chats = JSON.parse(localStorage.getItem('personal_chats')) || [];
    const updatedChats = chats.filter(chat => chat.id !== chatId);
    localStorage.setItem('personal_chats', JSON.stringify(updatedChats));
}

const syncChatMessages = (chatId, message) => {
    const chats = JSON.parse(localStorage.getItem('personal_chats')) || [];
    const chat = chats.find(chat => chat?.id === chatId);

    if (!chat) return;

    const messages = chat.messages || [];
    const messageIndex = messages.findIndex(m => m.id === message.id);

    if (messageIndex > -1) {
        messages[messageIndex] = message;
    } else {
        let inserted = false;
        for (let i = 0; i < messages.length; i++) {
            if (message.id < messages[i].id) {
                messages.splice(i, 0, message);
                inserted = true;
                break;
            }
        }
        if (!inserted) {
            messages.push(message);
        }
    }

    chat.messages = messages;
    const updatedChats = chats.map(c => c?.id === chatId ? chat : c);
    localStorage.setItem('personal_chats', JSON.stringify(updatedChats));
};

const DeliveredToAll = (chats, userId) => {
    chats?.forEach(chat => {
        const localChat = getChat(chat?.id);
        if (!localChat) return;
        localChat.messages = localChat.messages?.map(message => {
            if (message?.sender?.id === userId && message?.delivered_to_all === false && chat?.message_ids?.includes(message?.id)) {
                message.delivered_to_all = true;
            }
            return message;
        });
        syncChat(localChat);
    });
}

const SeenByAll = (chat, userId) => {
    const localChat = getChat(chat?.id);
    if (!localChat) return;
    localChat.messages = localChat.messages?.map(message => {
        if (message?.sender?.id === userId && message?.seen_by_all === false && chat?.message_ids?.includes(message?.id)) {
            message.seen_by_all = true;
        }
        return message;
    });
    syncChat(localChat);
}

const clearChats = () => {
    localStorage.removeItem('personal_chats');
    localStorage.removeItem('personal_chatList');
}

export { clearChats, deleteChat, DeliveredToAll, getChat, getChatList, getFirstChat, pushMoreChat, SeenByAll, setChatList, syncChat, syncChatMessages };
